export const ToTitleCase = (str: string): string =>
  str
    .toLowerCase()
    .split(/\s+/)
    .map((x) => x.charAt(0).toUpperCase() + x.substring(1))
    .join(" ");
